<template>
<img alt="SpiriSell logo" src="./assets/logo.png" style="width: 400px;">
  <HelloWorld msg="Welcome to SpiriSell Surgical"/>
</template>


<script>
import HelloWorld from './components/HelloWorld.vue'
export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
